// TODO: Move all cart tracking events here.
export var trackKlaviyo = function trackKlaviyo() {
  /* eslint-disable no-underscore-dangle */
  var KLAVIYO_PRODUCT = window.OV.KLAVIYO_PRODUCT;

  var _learnq = window._learnq || [];

  if (!KLAVIYO_PRODUCT) {
    console.warn('unable to track with Klaviyo');
    return;
  }

  _learnq.push(['track', 'Add To Cart', KLAVIYO_PRODUCT]);

  window._learnq = _learnq;
};
/*
 * A function to track additions to the cart.
 */

export var trackFB = function trackFB(_ref) {
  var variantId = _ref.variantId,
      title = _ref.title,
      price = _ref.price,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'USD' : _ref$currency;

  if (typeof window.fbq === 'undefined') {
    console.warn('unable to track with Facebook', title, variantId, price);
    return;
  }

  window.fbq('track', 'AddToCart', {
    currency: currency,
    content_name: title,
    content_type: 'product',
    content_ids: [parseInt(variantId, 10)],
    value: price,
    num_items: 1
  }); // console.info(
  //   'FB',
  //   JSON.stringify({
  //     currency,
  //     content_name: title,
  //     content_type: 'product',
  //     content_ids: [parseInt(variantId, 10)],
  //     value: price,
  //     num_items: 1,
  //   }),
  // );
};
export var trackAddToCart = function trackAddToCart(variant) {
  trackKlaviyo();
  trackFB(variant);
};